import React from 'react';

const Loader = ({
  primaryColor,
  accentColor = 'white',
  style = {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }
}): JSX.Element => {
  return (
    <>
      <style type="text/css">
        {`
          @keyframes loaderPulse {
            0% {
              box-shadow:
                0 0 2px 2px ${accentColor},
                0 0 0 0 ${primaryColor};
            }
          }
        `}
      </style>
      <div style={style}>
        <div style={{
          position: 'relative',
          width: '2.5rem',
          height: '2.5rem',
        }}>
          <div style={{
            position: 'absolute',
            left: '35%',
            top: '35%',
            width: '30%',
            height: '30%',
            backgroundColor: primaryColor,
            borderRadius: '100%',
            animation: 'loaderPulse 1.75s ease-out infinite',
            boxShadow: `
              0 0 5px 0 ${accentColor},
              0 0 1.25rem 1rem ${accentColor}
            `
          }}></div>
        </div>
      </div>
    </>
  );
};

export default Loader;
